const BlogContent = [
    {
        images: '01',
        title: ' Clever online POS arabic system',
        category: 'MassCloud'
    },
    {
        images: '02',
        title: 'Online car services ERP ',
        category: 'Car Aj'
    },

    {
        images: '03',
        title: 'Online timesheet system',
        category: 'MassTime'
    },
    // {
    //     images: '04',
    //     title: ' Getting tickets to the big show',
    //     category: 'Development'
    // },
    // {
    //     images: '01',
    //     title: 'A big ticket gone to be an interesting ',
    //     category: 'Management'
    // },
    // {
    //     images: '02',
    //     title: 'The Home of the Future Could Bebes',
    //     category: 'Design'
    // },
]

export default BlogContent;